import React from "react";
import { VideoModal } from "./VideoModal";
import { VideoPlaceHolder } from "./VideoPlaceHolder";

export const VideoPlayer = ({ videoId }: { videoId: string }) => {
  const [showVideo, setShowVideo] = React.useState(false);

  return (
    <>
      <div id="cn-video-modal" />
      <VideoModal
        videoId={videoId}
        show={showVideo}
        onClose={() => setShowVideo(false)}
      />
      <div
        className="tw:w-full tw:cursor-pointer "
        onClick={() => setShowVideo(true)}
      >
        <VideoPlaceHolder videoId={videoId} />
      </div>
    </>
  );
};
